<template>

  <tbody v-if="isLoading">
    <tr>
      <td colspan="1000" class="text-center" align="middle">
        <p class="loading-dots-text">{{ t('datatable.body.loading-records') }}</p>
      </td>
    </tr>
  </tbody>
  <tbody v-else-if="(data.length <= 0) && !isLoading">
    <tr>
      <td colspan="1000" class="text-center">
        {{ t('datatable.body.zero-records') }}
      </td>
    </tr>
  </tbody>
  <tbody v-else-if="(data.length > 0) && !isLoading">
    <template v-for="(row, index1) in data" :key="index1">
      <tr :class="getRowCssClass(row)">
        <template v-for="(column, index2) in columns" :key="index2">
          <template v-if="Object.keys(row).find(key => key === column.key)">
            <td :class="column.cssClass"
              v-if="!column.isAction && (column.isHide == false || column.isHide == undefined)"
              @click="onRowClick(row)">
              {{ row[column.key] }}
            </td>
            <template v-else>
              <td :class="column.cssClass"
                v-if="typeof column.component ==='object' && (column.isHide == false || column.isHide == undefined)">
                <component :is="column.component" :row="row" :column="column" :actionsUrl="column.actionsUrl"
                  :permissions="column.permissions" 
                  @customEventBody="handleEvent"
                  @customButtonAction="handleCustomButtonEvent"
                  ></component>
              </td>
            </template>
          </template>
        </template>
      </tr>
    </template>
    <tr v-if="hasTotalSumRow" class="total-row">
      <td>Total</td>
      <td v-for="(total, index) in totalSumRow" :key="index">
        {{total}}
      </td>
    </tr>
  </tbody>

</template>

<script>
import { onMounted, ref, watch } from 'vue'
import {useI18n} from 'vue-i18n'
import { formatNumberToMoney } from '@/utils/currencyUtils'


export default {
  props: {
    columns: {
      required: true,
      type: Array,
    },
    data: Array,
    language: Object,
    isLoading: Boolean,
    rowGeneralClass: {
      type: String,
      default: 'adjr-class',
      required: false
    },
    rowDynamicClass: {
      type: String,
      required: false
    },
    hasTotalSumRow: Boolean,
    totalSums: Object
  },
  emits: ['onRowClick', 'customEventBody', 'customButtonAction'],
  setup(props, {emit}) {
    const {t} = useI18n()
    const totalSumRow = ref([]);
    const getRowCssClass = (row) => {
      let cssClass = props.rowGeneralClass || ''
      if (props.rowDynamicClass) {
        cssClass += ' ' + row[props.rowDynamicClass]
      }
      return cssClass
    }
    const prepareTotalSumRows = () => {      
      totalSumRow.value = [];
      if (props.hasTotalSumRow) {        
        for (let i = 1; i < props.columns.length; i++) {
          totalSumRow.value.push(props.columns[i]['totalKey'] ? formatNumberToMoney(props.totalSums[props.columns[i]['totalKey']], 2) : null)
        }        
      }
    }
    const onRowClick = (row) => {
      emit('onRowClick', row)
    }

    const handleEvent = (event) => {
      emit('customEventBody', event)
    }

    const handleCustomButtonEvent = (event) => {
      emit('customButtonAction', event)
    }

    watch(() => props.isLoading, (newValue) => {      
      if (!props.isLoading && props.totalSums) {        
        prepareTotalSumRows();
      }
    });

    return {
      totalSumRow,
      getRowCssClass,
      onRowClick,
      handleEvent,
      handleCustomButtonEvent,
      t
    }
  }
}
</script>
<style scoped>
.full-div {
  width: 100% !important;
}
.total-row td {
  font-weight: 500 !important;
  color: black !important;
}
</style>